import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bcbf0ab4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "launch-countdown"
};
const _hoisted_2 = {
  class: "launch-countdown-item-time"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "launch-countdown-item-txt"
}, "D", -1));
const _hoisted_4 = {
  class: "launch-countdown-item-time"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "launch-countdown-item-txt"
}, "H", -1));
const _hoisted_6 = {
  class: "launch-countdown-item-time"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "launch-countdown-item-txt"
}, "M", -1));
const _hoisted_8 = {
  class: "launch-countdown-item-time"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "launch-countdown-item-txt pr0"
}, "S", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString($props.data.d), 1), _hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString($props.data.h), 1), _hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString($props.data.m), 1), _hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString($props.data.s), 1), _hoisted_9]);
}